// extracted by mini-css-extract-plugin
module.exports = {"dropdown":"style_dropdown__1ENgf","avatar":"style_avatar__29bnI"};